// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"75862117","364":"c3ab8ee4","483":"184bdca0","596":"30bc494a","787":"946f011a"}[chunkId] + ".chunk.js";
};